import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftSetAutocompleteResponse } from '@/repositories/generated';

const response: GiftSetAutocompleteResponse[] = [
  {
    id: '1',
    name: 'モック商品券セット1',
  },
  {
    id: '2',
  },
  {
    id: '3',
    name: 'モック商品券セット3',
  },
];

export const autocompleteGiftSet = http.get(
  createMockEndpoint('/autocomplete/gift_set'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
